import get from 'lodash/get'
import set from 'lodash/set'
import ReactDOM, { createRoot } from 'react-dom/client'
import React from 'react'

export default class ReactRenderer {

    static components = {}

    static registerComponent (component, componentName) {
        if (typeof componentName === 'undefined') {
            componentName = component.name
        }
        if (get(ReactRenderer.components, componentName)) {
            throw new Error(`Component ${componentName} already registered`)
        }

        set(ReactRenderer.components, componentName, component)
    }

    static render () {
        document.querySelectorAll('[data-react-class]').forEach((element) => {
            let components = this.components

            let Component = get(components, element.dataset.reactClass)
            let props = element.dataset.reactProps ? JSON.parse(element.dataset.reactProps) : {}

            if (typeof Component === 'undefined' || Component === null) {
                throw new Error('Failed to mount react component: ' + element.dataset.reactClass)
            }

            let JSX = (<Component {...props}/>)

            createRoot(element).render(JSX)
        })
    }
}
